import React from 'react';

import Loader from './Loader';
import useResponsive from '../../hooks/useResponsive';
import styles from '../../styles/views/components/AppLoader.module.scss';

const AppLoader = () => {
  const { isMobile, isTablet, isDesktop } = useResponsive();

  return (
    <div className={styles.wrapper}>
      {isMobile && <Loader width="100px" height="100px" />}
      {isTablet && <Loader width="120px" height="120px" /> }
      {isDesktop && <Loader width="180px" height="180px" /> }
      <div className={styles.text}>Application initialization</div>
    </div>
  );
};

export default AppLoader;
